const getApiVersion = (): string => {
  // eslint-disable-next-line no-underscore-dangle
  const apiVersion = (globalThis as { __API_VERSION__?: string }).__API_VERSION__;
  return typeof apiVersion === 'string' ? apiVersion : '';
};

export default getApiVersion;
